import { Button, ContextMenu, Icon, Li, Loading } from '@startlibs/components';
import {getColor, isMobile, postFetcher} from '@startlibs/utils';
import {usePopupToggle, useToggle} from '@startlibs/core';
import React, { useContext } from 'react'
import _ from 'lodash/fp'
import styled from 'styled-components';

import {DATE_FORMAT} from '../../config/DateFormat'
import {EditAssignmentDialog} from './EditAssignmentDialog'
import {EditStatusDialog} from './EditStatusDialog'
import {StudyCell} from './StudyCell'
import {ToolsCell} from './ToolsCell'
import {WorklistTableColumn} from './Table';
import {WorklistTableRow} from '../worklist/Table';
import {dicomDateToDate, formatNoUTCDate} from '../../utils'
import {setNotification} from '../../components/Notifications'
import {strToDate} from '../../utils/utils'
import { DicomRouterContext } from '../../utils/DicomRouterContext';

/*
const a = {
  "patient": {"patientName": "FVP01 SILVA^SOUZA^^^", "patientID": "009051929", "patientDOB": "19290905"},
  "study": {
    "modalities": "CT",
    "studyDescription": "2019-03-07 09:12:26 ",
    "studyDate": "2005-04-14 11:44:18",
    "imageCount": "57"
  },
  "physician": "EVERS^^^^",
  "institution": "VCI",
  "status": {
    "currentStatus": "Normal",
    "changeStatusWeblink": "priority_edit.php?curr=Normal&id=1162&name=FVP01 SILVA^SOUZA^^^&study="
  },
  "assignment": {
    "assignee": "demo3@purview.net",
    "reassignWeblink": "reassign.php?id=1162&name=FVP01 SILVA^SOUZA^^^&study="
  },
  "tools": {
    "viewStudyWeblink": "viewerlauncher.php?study_iuid=1.2.392.200036.9116.2.5.1.48.1215515078.1113444982.788741&pat_name=FVP01 SILVA^SOUZA^^^",
    "viewerLinkWeblink": "viewerlauncher.php?study_iuid=1.2.392.200036.9116.2.5.1.48.1215515078.1113444982.788741&pat_name=FVP01 SILVA^SOUZA^^^",
    "launchHorosWeblink": "osirix://?methodName=downloadURL&URL='https://download-us-east.purview.net/get/test.php?study_iuid=1.2.392.200036.9116.2.5.1.48.1215515078.1113444982.788741&host=&database=pacsdbsrdemo3",
    "downloadStudyWeblink": "https://download-us-east.purview.net/get/index.php?study_iuid=1.2.392.200036.9116.2.5.1.48.1215515078.1113444982.788741&host=&database=pacsdbsrdemo3",
    "downloadCDWeblink": "https://download-us-east.purview.net/get/test.php?study_iuid=1.2.392.200036.9116.2.5.1.48.1215515078.1113444982.788741&host=&database=pacsdbsrdemo3",
    "attachNonDicom": {"content": false, "weblink": ""},
    "studyNotes": {"content": true, "weblink": "notes_edit.php?id=1162"},
    "report": {"right": "rw", "reportStatus": "Reported", "weblink": "reports_edit-ckeditor.php?id=1162"},
    "shareStudyWeblink": "sharestudy.php?study_iuid=1.2.392.200036.9116.2.5.1.48.1215515078.1113444982.788741&pat_name=FVP01 SILVA^SOUZA^^^",
    "markAsReadWeblink": "update_read.php?id=1162"
  }
}*/

const TableCellButton = styled.div`
  display: inline-block;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  border-radius: 5px;
  position: relative;
  :hover {
    background: rgba(41, 122, 163, 0.125);
  }
  :active {
    background: rgba(41, 122, 163, 0.175);
  }
  ${props => props.active && `
    background: rgba(41, 122, 163, 0.125);
  `}
  ${Icon} {
    font-size: 16px;
    vertical-align: -3px;
    color: rgba(0,0,0,0.57);
  }
  i {
    color: rgba(0,0,0,0.4);
  }
`
const STATUS_TO_COLOR = {
  'normal': 'success',
  'stat': 'alert',
  'time sensitive': 'warning',
}

const CaseStatus = styled.span`
  color: ${props => getColor(STATUS_TO_COLOR[(props.status || "").toLowerCase()] || "gray120")(props)};
  font-weight: 600;
`
const DisabledCaseStatus = styled(CaseStatus)`
  color: ${getColor('gray120')};
`


const LoadingAssignee = styled(Loading)`
  vertical-align: text-bottom;
  display: inline-block;
  margin-right: 0.5rem;
`
const RetryButton = styled(Button)`
  color: ${getColor('alert')};
  font-weight: 600;
  margin-left: 1rem;
  margin-top: -2px;
  margin-bottom: -2px;
`

export const StudyRow = ({activeToolsAmount, setParams, study, refreshList, setStudy, userRights, hasHorizontalScroll, isArchived, unarchivingPanel, setUnarchivingWorklist, setInvalidateCache, setUnarchivingTimeoutIds, usingUnarchiver, userLogin, setStudies, setCurrentQuantity}) => {
  
  const uploadDate = strToDate(study.study.uploadDate)
  const formattedUploadDate = isNaN(uploadDate.getTime()) ? "" : formatNoUTCDate(uploadDate, DATE_FORMAT())
  const studyDate = strToDate(study.study.studyDate)
  const formattedStudyDate = isNaN(studyDate.getTime()) ? "" : formatNoUTCDate (studyDate, DATE_FORMAT())

  const assigneeMenu = usePopupToggle()

  const unassignLoading = useToggle()
  const statusDialog = useToggle()
  const assigneeDialog = useToggle()

  // const studyUid = study.study.iuid;
  const unassign = () => {
    unassignLoading.wait(
      postFetcher("/new_reassign_update.php", {study_assigned_to: "",id: study.study.id})
        .then(() => {
          console.log("??")
          setStudy(_.set('assignment.assignee', ''))
        })
        .catch(() => {
          setStudy(_.set('assignment.assignee', study.assignment.assignee))
          setNotification({type:"alert",msg:<>Assignment update could not be saved. <RetryButton small white onClick={unassign}>Retry</RetryButton></>})
        })
    )
  }

  return <WorklistTableRow isMobile={isMobile()} isArchived={isArchived}>
    {userRights.patient.visible &&
    <WorklistTableColumn className="patient"><PatientCell className='notranslate' patient={study.patient}/></WorklistTableColumn>}
    {userRights.study.visible &&
    <WorklistTableColumn className="study"><StudyCell
      refreshList={refreshList}
      setStudy={setStudy}
      setParams={setParams}
      study={study.study}
    /></WorklistTableColumn>}
    {userRights.study.visible &&
    <WorklistTableColumn className="studyDate">{formattedStudyDate}</WorklistTableColumn>
    }
    {userRights.physician.visible && <WorklistTableColumn className='notranslate'>{study.physician}</WorklistTableColumn>}
    {userRights.institution.visible && <WorklistTableColumn className='notranslate'>{study.institution}</WorklistTableColumn>}
    {userRights.performingPhysician?.visible && <WorklistTableColumn className='notranslate'>{study.perfPhysician}</WorklistTableColumn>}
    {userRights.assignment.visible && <WorklistTableColumn>
      {
        study.tools.report.reportStatus === "Reported"
          ? study.assignment.assignee
          : !isArchived 
            ?
              <TableCellButton
                onClick={study.assignment.assignee ? assigneeMenu.open : assigneeDialog.open}
                active={assigneeMenu.isOpen}
              >
                {
                  unassignLoading.isOpen ?
                  <><LoadingAssignee size={18}/><i>Updating</i></>
                  :
                  <>{study.assignment.assignee ? study.assignment.assignee : <i>Unassigned</i>} <Icon icon="edit-box"/></>
                }
                {
                  assigneeMenu.isOpen &&
                  <ContextMenu>
                    <Li label="Change assignment" onClick={assigneeDialog.open}/>
                    <Li label="Unassign" onClick={unassign}/>
                  </ContextMenu>
                }
              </TableCellButton>
            : study.assignment.assignee 
              ? study.assignment.assignee 
              : <i>Unassigned</i>
      }
      {
        assigneeDialog.isOpen &&
        <EditAssignmentDialog study={study} setStudy={setStudy} closeDialog={assigneeDialog.close}/>
      }
    </WorklistTableColumn>}
    {userRights.status.visible && <WorklistTableColumn className="status">
      {
        study.tools.report.reportStatus === "Reported"
          ? <CaseStatus status={study.status.currentStatus}>{study.status.currentStatus}</CaseStatus>
          : !isArchived 
            ? <TableCellButton onClick={statusDialog.open} css="max-width:80px;">
                <CaseStatus status={study.status.currentStatus}>{study.status.currentStatus}</CaseStatus> <Icon icon="edit-box"/>
              </TableCellButton>
            : <DisabledCaseStatus status={study.status.currentStatus}>{study.status.currentStatus}</DisabledCaseStatus>
      }
      {
        statusDialog.isOpen &&
        <EditStatusDialog study={study} setStudy={setStudy} closeDialog={statusDialog.close} setInvalidateCache={setInvalidateCache}/>
      }
    </WorklistTableColumn>}
    {userRights.uploadDate.visible &&
    <WorklistTableColumn className="uploadDate">{formattedUploadDate}</WorklistTableColumn>}
    {userRights.tools.visible &&
    <WorklistTableColumn
      className="tools JS-fix-dialog-scroll" activeToolsAmount={activeToolsAmount}
      hasHorizontalScroll={hasHorizontalScroll} isMobile={isMobile()}
    >
      <ToolsCell isArchived={isArchived} 
        refreshList={refreshList} 
        userRights={userRights} 
        study={study} 
        setStudy={setStudy} 
        setParams={setParams} 
        unarchivingPanel={unarchivingPanel} 
        setUnarchivingWorklist={setUnarchivingWorklist} 
        setInvalidateCache={setInvalidateCache} 
        setUnarchivingTimeoutIds={setUnarchivingTimeoutIds} 
        usingUnarchiver={usingUnarchiver} 
        userLogin={userLogin}
        setStudies={setStudies}
        setCurrentQuantity={setCurrentQuantity}
      />
    </WorklistTableColumn>}
  </WorklistTableRow>
}

const PatientCell = ({patient}) => {
  const dob = dicomDateToDate(patient.patientDOB)
  const formattedDob = isNaN(dob.getTime()) ? "" : formatNoUTCDate(dob, DATE_FORMAT(), undefined, true)

  return <>
    <div className='notranslate'><b>{patient.patientName}</b></div>
    <div className='notranslate'><span css="margin-right:0.75rem"><b>ID:</b> {patient.patientID}</span> <span
      className="nowrap"
    ><b>DOB:</b> {formattedDob}</span></div>
  </>
}
